export enum DeliveryType {
  ALL = 'ALL',
  TAKEAWAY = 'TAKEAWAY',
  DELIVERY = 'DELIVERY',
}
